import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';

interface Props {
  productTag: {
    name: string;
    icon: string;
    href: string;
  };
}

const ProductTag = ({ productTag }: Props) => {
  return (
    <a
      href={productTag.href}
      css={productTagStyles}
      onClick={(e) => e.preventDefault()} // Prevent navigation for now
    >
      {productTag.icon} {productTag.name}
    </a>
  );
};

const productTagStyles = css({
  padding: '4px 8px',
  fontSize: '12px',
  fontWeight: 500,
  color: token('color.text.subtle'),
  textDecoration: 'none',
  fontFamily: 'Inter, sans-serif',
  '&:hover': {
    color: token('color.text'),
  },
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '11px',
    padding: '3px 6px',
  },
});

export default ProductTag;
